// Login.jsx (auth.js)

import React from "react";
import "./Auth.css";

import Logo from "../../../Assets/LoginScreenAdmin/Logo.png";
import Illustration from "../../../Assets/LoginScreenAdmin/Group 1.png";
import Shield from "../../../Assets/LoginScreenAdmin/Shield Done.png";

import InputError from "../../../Component/InputError/InputError";
import useAuth from "./Logic";

import { FaEye, FaEyeSlash } from "react-icons/fa";

import Tooltip from "../../../Component/ToolTip/ToolTips";
import { TOOLTIP_MESSAGES } from "../../../Component/ToolTip/messages";

export default function Login() {
  const {
    email,
    setEmail,
    password,
    setPassword,
    emailError,
    passwordError,
    apiError,
    handleLogin,
    isValid,
    loading,
  } = useAuth();

  const [showPassword, setShowPassword] = React.useState(false);
  const [showTip, setShowTip] = React.useState(false);
  const [mousePos, setMousePos] = React.useState({ x: 0, y: 0 });

  const shouldShowEmailTip = email.length === 0;
  const shouldShowPasswordTip = password.length === 0;

  const handleMouseMove = (e) => {
    setMousePos({ x: e.clientX, y: e.clientY });
  };

  return (
    <div className="login-container">

      {/* LEFT SECTION */}
      <div className="left-section">
        <div className="logo-row">
          <img src={Logo} alt="Fliplyn" className="logo-img" />
          <span className="logo-text">Fliplyn</span>
        </div>

        <div className="illustration-block">
          <img src={Illustration} alt="Illustration" className="illustration-img" />
        </div>

        <h1 className="tagline">Smart. Fast. Connected.</h1>
        <p className="subtext">
          Manage your Fliplyn ecosystem <br /> with confidence.
        </p>
        <p className="footer">©2025 Fliplyn Admin Console · Secure Access</p>
      </div>

      {/* RIGHT SECTION */}
      <div className="right-section">
        <div className="login-card">
          <h2 className="login-title">Admin Login</h2>
          <p className="login-desc">Enter your admin credentials to access the dashboard</p>

          {/* EMAIL */}
          <div
            className="tooltip-wrapper"
            style={{ position: "relative" }}
            onMouseMove={handleMouseMove}
            onMouseEnter={() => shouldShowEmailTip && setShowTip("email")}
            onMouseLeave={() => setShowTip(false)}
          >
            <label className="input-label">Email</label>

            <input
              type="email"
              className={`input-box ${emailError ? "input-error-border" : ""}`}
              placeholder="admin@fliplyn.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <InputError message={emailError} />

            {showTip === "email" && shouldShowEmailTip && (
              <Tooltip x={mousePos.x} y={mousePos.y} message={TOOLTIP_MESSAGES.email} />
            )}
          </div>

          {/* PASSWORD */}
          <div
            className="tooltip-wrapper"
            style={{ position: "relative", display: "flex", flexDirection: "column" }}
            onMouseMove={handleMouseMove}
            onMouseEnter={() => shouldShowPasswordTip && setShowTip("password")}
            onMouseLeave={() => setShowTip(false)}
          >
            <label className="input-label">Password</label>

            <div className="password-wrapper" style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                className={`input-box ${passwordError ? "input-error-border" : ""}`}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <span
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              >
                {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
              </span>
            </div>

            <InputError message={passwordError} />

            {showTip === "password" && shouldShowPasswordTip && (
              <Tooltip x={mousePos.x} y={mousePos.y} message={TOOLTIP_MESSAGES.password} />
            )}
          </div>

          {/* LOGIN BUTTON */}
          <div
            className="tooltip-wrapper"
            style={{ position: "relative" }}
            onMouseMove={handleMouseMove}
            onMouseEnter={() => !isValid && setShowTip("login")}
            onMouseLeave={() => setShowTip(false)}
          >
            <button
              className="login-btn"
              disabled={!isValid || loading}
              onClick={handleLogin}
            >
              {loading ? "Logging in..." : "Log In"}
            </button>

            {showTip === "login" && !isValid && (
              <Tooltip x={mousePos.x} y={mousePos.y} message={TOOLTIP_MESSAGES.login} />
            )}

            {apiError && (
              <p style={{ color: "red", marginTop: "8px" }}>{apiError}</p>
            )}
          </div>

          {/* SECURITY NOTICE */}
          <p className="security-text">
            <img src={Shield} alt="Security" className="shield" />
            This portal is for authorized Fliplyn administrators only. All actions are monitored and logged.
          </p>
        </div>
      </div>
    </div>
  );
}
